<!-- <div class="custom-tab-wrapper my-4">
  <div class="custom-tab-buttons">
    <button [ngClass]="{ active: selectedTab === 0 }" (click)="selectedTab = 0">
      Unprocessed
    </button>
    <button [ngClass]="{ active: selectedTab === 1 }" (click)="selectedTab = 1">
      Processed
    </button>

  </div>

  <div class="custom-tab-content">
    <ng-container [ngSwitch]="selectedTab">
      <app-issuer-unprocessed *ngSwitchCase="0"></app-issuer-unprocessed>
      <app-issuer-processed *ngSwitchCase="1"></app-issuer-processed>

    </ng-container>
  </div>
</div> -->
<div class="custom-tab-wrapper my-4">
  <div class="custom-tab-buttons">
    <button [ngClass]="{ active: selectedTab === 0 }" (click)="selectedTab = 0">
      Unprocessed
    </button>
    <button [ngClass]="{ active: selectedTab === 1 }" (click)="selectedTab = 1">
      Processed
    </button>
    <button [ngClass]="{ active: selectedTab === 2 }" (click)="selectedTab = 2">
      Duplicate by CIK
    </button>
    <!-- <button [ngClass]="{ active: selectedTab === 2 }" (click)="selectedTab = 2">
      Unreferenced
    </button> -->
  </div>

  <div class="custom-tab-content">
    <ng-container [ngSwitch]="selectedTab">
      <app-issuer-unprocessed
        *ngSwitchCase="0"
        [isActive]="isActive && selectedTab === 0"
      ></app-issuer-unprocessed>

      <app-issuer-processed
        *ngSwitchCase="1"
        [isActive]="isActive && selectedTab === 1"
      ></app-issuer-processed>

      <app-duplicate-by-cik
        *ngSwitchCase="2"
        [isActive]="isActive && selectedTab === 2"
      ></app-duplicate-by-cik>
    </ng-container>
  </div>
</div>
